import React, { useEffect, useState } from 'react'
import { I18n } from 'react-redux-i18n'

import './styles.scss'
import { InputControls } from 'components/common'
import { Button, SelectWithLabel } from 'components/Form'
import { getStaticImage } from 'utils/statics'

const SubjectsOptions = ({
  type,
  subjects,
  chatmailCheckedSubjects,
  chatmailAllCheckedSubjects,
  handleAllCheckedSubjects,
  handleChangeMultipleSubjects,
  subjectsFilterOptions,
  filterValues,
  setFilterValues,
  statesOptions,
  openOutboundAction
}) => {
  const [stateValue, setStateValue] = useState(' ')
  const [readValue, setReadValue] = useState(true)

  useEffect(() => {
    if (!Object.keys(chatmailCheckedSubjects).length) return

    if (type === 'actions') {
      getStateValue()
      getReadValue()
    }
  }, [Object.keys(chatmailCheckedSubjects)])

  const getStateValue = () => {
    const subject = subjects.find(subject => subject._id === Object.keys(chatmailCheckedSubjects)[0])
    let stateValue = statesOptions.find(state => state.value === subject.state)
    setStateValue(stateValue)
  }

  const getReadValue = () => {
    let readValue = subjects.find(subject => subject._id === Object.keys(chatmailCheckedSubjects)[0]).read
    setReadValue(readValue)
  }

  return (
    <div className='chatmail-subjects-options'>
      <InputControls
        injectType='external'
        className='chat-composer__subjects-checkbox'
        type='checkbox-multiple'
        value={chatmailAllCheckedSubjects}
        onChange={handleAllCheckedSubjects}
      />
      {type === 'filters' ? (
        <SelectWithLabel
          isClearable
          classNameWrapper='chat-composer__subjects-filter'
          placeholder={I18n.t('dashboard_all')}
          options={subjectsFilterOptions}
          value={filterValues.type}
          onChange={value => setFilterValues(prevState => ({ ...prevState, type: value }))}
        />
      ) : null}
      {type === 'filters' ? (
        <SelectWithLabel
          isClearable
          classNameWrapper='chat-composer__subjects-filter'
          placeholder={I18n.t('dashboard_all')}
          options={statesOptions}
          value={filterValues.state}
          onChange={value => setFilterValues(prevState => ({ ...prevState, state: value }))}
        />
      ) : null}
      {type === 'actions' ? (
        <SelectWithLabel
          classNameWrapper='chat-composer__subjects-filter'
          options={statesOptions}
          value={stateValue}
          onChange={({ value }) => handleChangeMultipleSubjects({ type: 'state', value })}
        />
      ) : null}
      {type === 'filters' ? (
        <button
          className='chat-composer__subjects-read-btn'
          onClick={() => setFilterValues(prevState => ({ ...prevState, isRead: !prevState.isRead }))}
        >
          <figure>
            {!filterValues.isRead ? (
              <img src={getStaticImage('/icons/orange-brand/icon-read-on.svg')} alt='Unread messages' />
            ) : (
              <img src={getStaticImage('/icons/orange-brand/icon-read-off.svg')} alt='Read messages' />
            )}
          </figure>
          {!filterValues.isRead && <div className='chatmail-subjects-options__active-bar'></div>}
        </button>
      ) : null}
      {type === 'actions' ? (
        <button
          className='chat-composer__subjects-read-btn'
          onClick={() => handleChangeMultipleSubjects({
            type: 'read',
            value: !readValue
          })}
        >
          <figure>
            {!readValue ? (
              <img src={getStaticImage('/icons/orange-brand/icon-read-on.svg')} alt='Unread messages' />
            ) : (
              <img src={getStaticImage('/icons/orange-brand/icon-read-off.svg')} alt='Read messages' />
            )}
          </figure>
          {!readValue && <div className='chatmail-subjects-options__active-bar'></div>}
        </button>
      ) : null}
      <div className='input-container'>
        <i className="fa fa-search"></i>
        <input
          type='text'
          placeholder={I18n.t('dashboard_search_subject')}
          value={filterValues.text || ''}
          onChange={event => setFilterValues({ ...filterValues, text: event.target.value })}
        />
        {filterValues.text ? (
          <i
            className='fa fa-times'
            onClick={() => setFilterValues(prevState => ({ ...prevState, text: '' }))}
          ></i>
        ) : null}
      </div>
      <Button
        primary
        small
        value={I18n.t('btn_write')}
        onClick={() => openOutboundAction({ channel: 'chatmail' })}
      />
    </div>
  )
}

export default SubjectsOptions
